var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEqualizer = function SvgEqualizer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "equalizer_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#equalizer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.215 17.083q-.63 0-1.069-.437a1.45 1.45 0 0 1-.437-1.07V3.126q0-.266.18-.445.18-.18.445-.18.266 0 .445.18.18.18.18.445v12.452q0 .096.08.176t.176.08h12.452q.266 0 .445.18.18.18.18.445 0 .267-.18.446a.6.6 0 0 1-.445.18zM6.3 14.375a.7.7 0 0 1-.514-.207.7.7 0 0 1-.207-.514V8.3q0-.306.207-.514a.7.7 0 0 1 .514-.207h1.025q.321 0 .537.217a.73.73 0 0 1 .217.538v5.288a.73.73 0 0 1-.217.536.73.73 0 0 1-.537.216zm3.958 0a.7.7 0 0 1-.514-.207.7.7 0 0 1-.207-.514V4.167q0-.321.217-.537a.73.73 0 0 1 .536-.216h1.026q.306 0 .514.207.207.208.207.514v9.487a.73.73 0 0 1-.217.536.73.73 0 0 1-.536.217zm3.958 0a.7.7 0 0 1-.514-.207.7.7 0 0 1-.207-.514v-1.987q0-.321.217-.537a.73.73 0 0 1 .537-.216h1.025q.306 0 .514.207.207.207.207.514v1.987a.73.73 0 0 1-.216.536.73.73 0 0 1-.537.217z"
  }))));
};
export default SvgEqualizer;